module.exports = __webpack_public_path__ + "static/media/i&k.ca7e09a5.png";